/**
 * Function-oriented buckets we surface in the Discover tab. Mirrors recommander's
 * own row-0 sections, plus Utility Lands. We deliberately ignore the per-card-type
 * buckets (Creature, Artifact, …) — duplicative with our own categorisation.
 */
export const RECOMMANDER_FUNCTION_BUCKETS = [
    'Ramp',
    'SpotRemoval',
    'MassRemoval',
    'CardAdvantage',
    'Tutors',
    'UtilityLands',
    'Staples',
];
/**
 * Full set of buckets we surface in the chip filter. 'Top' is a virtual bucket
 * that maps to the headline `recommendations` list filtered to !generic — it
 * isn't a real key in `typed_recommendations`, so useSearch has to resolve it
 * specially.
 */
export const RECOMMANDER_BUCKETS = [
    'Top',
    ...RECOMMANDER_FUNCTION_BUCKETS,
];
/** Display-ready label for each bucket key, mirroring recommander.cards's own UI. */
export const RECOMMANDER_BUCKET_LABELS = {
    Top: 'Top',
    Ramp: 'Ramp',
    SpotRemoval: 'Spot Removal',
    MassRemoval: 'Mass Removal',
    CardAdvantage: 'Card Advantage',
    Tutors: 'Tutors',
    UtilityLands: 'Utility Lands',
    Staples: 'General Staples',
};
/**
 * Slug each bucket maps to in the search bar's `rectag:<slug>` clause —
 * mirrors otag: (lowercased, hyphen-separated). The bar is the source of
 * truth; useSearch parses these out and serves the bucket directly from
 * the recommendations cache.
 */
export const RECOMMANDER_BUCKET_SLUGS = {
    Top: 'top',
    Ramp: 'ramp',
    SpotRemoval: 'spot-removal',
    MassRemoval: 'mass-removal',
    CardAdvantage: 'card-advantage',
    Tutors: 'tutors',
    UtilityLands: 'utility-lands',
    Staples: 'staples',
};
/** Reverse lookup: rectag slug → bucket key. */
export const RECOMMANDER_SLUG_TO_BUCKET = Object.fromEntries(Object.entries(RECOMMANDER_BUCKET_SLUGS).map(([bucket, slug]) => [slug, bucket]));
//# sourceMappingURL=api.js.map